module.exports = __webpack_public_path__ + "img/xgsp@2X.947b34ed.png";